import { Grid, Tooltip } from "@mui/material";
import DrawerCM from "components/shared/Drawer";
import EnhancedTable from "components/shared/Table";
import generateHeadCells from "helper/generate-head-cell";
import useHttp from "hooks/use-http";
import React from "react";
import { useState } from "react";
import { StyledGlBtn, StyledIconButton } from "styles/globals";
import { Delete, Launch } from "@mui/icons-material";
import { useEffect } from "react";
import LoadingCM from "components/shared/Loading";
import { TAGS_DUMMY_DATA } from "data";
import TextFieldCm from "components/shared/TextField";
import { useForm } from "react-hook-form";
import StackCm from "components/shared/StackCm";
import { yupResolver } from "@hookform/resolvers/yup";
import addNewTagSchema from "validations/tags";
import {
  addBlogTagRequest,
  deleteBlogTagRequest,
  getBlogTagsRequest,
} from "api/blogTags";
import Toast from "helper/toast";
import BackButton from "components/shared/BackButton";
import { useParams } from "react-router-dom";

const headCell = generateHeadCells("blog_tags");

export default function BlogTags() {
  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(addNewTagSchema) });

  const { id } = useParams();

  const [data, setData] = useState({
    count: 0,
    data: [{ content: "هیچ تگی برای این وبلاگ یافت نشد" }],
  });

  const { loading, request } = useHttp(false);

  const deleteTagHandler = async (id) => {
    const res = await request({
      url: deleteBlogTagRequest,
      values: id,
    });
    if (res) {
      Toast({ type: "success", title: "حذف تگ" });
    }
    getData();
  };

  const onSubmit = async (data) => {
    const res = await request({
      url: addBlogTagRequest,
      values: { ...data, blog_id: id },
    });

    if (res) {
      Toast({ type: "success", title: "افزودن تگ" });
      reset({
        title: "",
        link: "",
      });
      getData();
    }
  };

  const getData = async () => {
    const res = await request({
      url: getBlogTagsRequest,
      values: {
        blog_id: id,
      },
    });

    if (!res.count) {
      return setData({
        count: 0,
        data: [{ content: "هیچ تگی برای این وبلاگ یافت نشد" }],
      });
    }
    if (res) {
      const transformedData = res.data.map((item) => ({
        id: item.id,
        title: item.title,
        tags: (
          <Tooltip title="بازکردن لینک" placement="top">
            <StyledIconButton
              variant="countaind"
              onClick={(e) => {
                e.stopPropagation();
                window.open(item.link, "_blank");
              }}
            >
              <Launch />
            </StyledIconButton>
          </Tooltip>
        ),
        delete: (
          <StyledIconButton
            variant="countaind"
            color="error"
            onClick={(e) => {
              e.stopPropagation();
              deleteTagHandler(item.id);
            }}
          >
            <Delete />
          </StyledIconButton>
        ),
      }));

      setData({
        data: transformedData,
        count: 1,
      });
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <DrawerCM title="تگ ها">
      {loading ? (
        <LoadingCM />
      ) : (
        <Grid container>
          <Grid item xs={12} mt={3}>
            <BackButton />
          </Grid>
          <Grid item xs={12} mb={2}>
            <StackCm title="افزودن تگ">
              <Grid container>
                <Grid item md={6} xs={12} p={1.5}>
                  <TextFieldCm
                    label={"عنوان"}
                    id={"title"}
                    register={register}
                    errors={errors}
                  />
                </Grid>
                <Grid item md={6} xs={12} p={1.5}>
                  <TextFieldCm
                    label={"لینک"}
                    id={"link"}
                    register={register}
                    errors={errors}
                  />
                </Grid>
                <StyledGlBtn title="ثبت" onClick={handleSubmit(onSubmit)} />
              </Grid>
            </StackCm>
          </Grid>
          <EnhancedTable
            rows={data.data}
            page={1}
            headCells={headCell}
            title="لیست تگ ها"
          />
        </Grid>
      )}
    </DrawerCM>
  );
}
